import {blacklistReducer, defaultBlacklistState, IBlacklistState} from './reducers/blacklist.reducer';
import {defaultFavoritesState, favoritesReducer, IFavoritesState} from './reducers/favorites.reducer';
import {defaultFamiliesState, familiesReducer, IFamiliesState} from './reducers/family.reducer';
import {
  defaultRemotesState,
  defaultRemoteState,
  IRemotesState,
  IRemoteState,
  remoteReducer,
  remotesReducer
} from './reducers/remote.reducer';
import {
  defaulIResortsState,
  defaultResortState,
  IResortsState,
  IResortState,
  resortReducer,
  resortsReducer
} from './reducers/resort.reducer';
import {defaultPlayerState, IPlayerState, playerReducer} from './reducers/player.reducer';
import {defaultScheduleState, IScheduleState, scheduleReducer} from './reducers/schedule.reducer';
import {activeDayReducer, IActiveDayState} from './reducers/active-day.reducer';
import {defaultWishlistState, IWishlistState, wishlistReducer} from './reducers/wishlist.reducer';
import {defaultPlaylistsState, IPlaylistsState, playlistsReducer} from './reducers/playlist.reducer';
import {defaultHistoryState, historyReducer, IHistoryState} from './reducers/history.reducer';
import {defaultUserState, IUserState, userReducer} from './reducers/user.reducer';
import {defaultHistoriesState, historiesReducer, IHistoriesState} from './reducers/histories.reducer';
import {ISchedule24State, schedule24Reducer} from './reducers/schedule24.reducer';
import {defaultPlaylistMwState, IPlaylistMw, playlistMwReducer} from './reducers/playlist-mw.reducer';
import {defaultProvider, IProviderState, providerReducer} from './reducers/provider.reducer';
import {audioDeviceReducer, defaultAudioDeviceState, IAudioDeviceState} from './reducers/audio-device.reducers';
import {getCurrentDay} from '../utils';
import {defaultPlayrulesState, IPlayrulesState, playrulesReducer} from './reducers/playrule.reducer';
import {defaultUserParamsState, IUserParamsState, userParamsReducer} from './reducers/user-params.reducer';

export interface PlaylistRemoteAppState {
  audio_devices: IAudioDeviceState;
  resorts: IResortsState;
  remotes: IRemotesState;
  resort: IResortState;
  remote: IRemoteState;
  player: IPlayerState;
  schedule: IScheduleState;
  scheduleDay: ISchedule24State;
  activeDay: IActiveDayState;
  families: IFamiliesState;
  wishlist: IWishlistState;
  favorites: IFavoritesState;
  playlists: IPlaylistsState;
  playlistsMw: IPlaylistMw;
  provider: IProviderState;
  blacklist: IBlacklistState;
  history: IHistoryState;
  histories: IHistoriesState;
  user: IUserState;
  playrules: IPlayrulesState;
  userParams: IUserParamsState;
}

export const defaultState: PlaylistRemoteAppState = {
  audio_devices: defaultAudioDeviceState,
  resorts: defaulIResortsState,
  remotes: defaultRemotesState,
  resort: defaultResortState,
  remote: defaultRemoteState,
  player: defaultPlayerState,
  schedule: defaultScheduleState,
  scheduleDay: {},
  activeDay: getCurrentDay(),
  families: defaultFamiliesState,
  wishlist: defaultWishlistState,
  favorites: defaultFavoritesState,
  playlists: defaultPlaylistsState,
  playlistsMw: defaultPlaylistMwState,
  provider: defaultProvider,
  blacklist: defaultBlacklistState,
  history: defaultHistoryState,
  histories: defaultHistoriesState,
  user: defaultUserState,
  playrules: defaultPlayrulesState,
  userParams: defaultUserParamsState
};


export const reducers = {
  audio_devices: audioDeviceReducer,
  resorts: resortsReducer,
  remotes: remotesReducer,
  resort: resortReducer,
  remote: remoteReducer,
  player: playerReducer,
  schedule: scheduleReducer,
  scheduleDay: schedule24Reducer,
  activeDay: activeDayReducer,
  wishlist: wishlistReducer,
  favorites: favoritesReducer,
  playlists: playlistsReducer,
  playlistsMw: playlistMwReducer,
  provider: providerReducer,
  families: familiesReducer,
  blacklist: blacklistReducer,
  history: historyReducer,
  histories: historiesReducer,
  user: userReducer,
  playrules: playrulesReducer,
  userParams: userParamsReducer
};

export * from './actions';
export * from './epics';
export * from './queries';
export * from './infra';
